<div class="topbar-new-wrapper">
  <!-- Top Blue Section (Hidden on Mobile) -->
  <div class="top-info-bar">
    <div
      class="container flex justify-content-between align-items-center h-full"
    >
      <div class="right-promo flex gap-4">
        <!-- <div class="promo-item flex align-items-center gap-2">
          <span class="active-dot"></span>
          <span style="line-height: 12px">FREE SHIPPING $175+</span>
        </div> -->
        <div class="promo-item flex align-items-center gap-2">
          <!-- <span class="divider">|</span> -->
          <span>24Hr Rush Available</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Middle Main Header Section -->
  <header class="main-header">
    <div
      class="container flex justify-content-between align-items-center h-full gap-2 md:gap-4"
    >
      <!-- Mobile Hamburger Menu Button -->
      <button
        class="mobile-menu-btn lg:hidden"
        (click)="toggleMobileMenu()"
        aria-label="Menu"
      >
        <i class="pi pi-bars"></i>
      </button>

      <!-- Logo Group -->
      <div class="flex align-items-center h-full flex-1 md:flex-none">
        <div class="logo-container cursor-pointer" routerLink="/">
          <img
            [src]="
              displayImage($currentUser()?.company?.logo_file || 'logo.png')
            "
            alt="Logo"
            class="main-logo"
          />
        </div>

        <!-- Desktop Search Bar (Hidden on Mobile) -->
        <div class="search-container hidden lg:block">
          <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
            <span class="p-input-icon-left w-full relative block">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInputText
                formControlName="search"
                (focus)="onSearchFocus()"
                (blur)="onSearchBlur()"
                placeholder="Search banners, stickers, business cards..."
                class="w-full search-input"
              />
              <button
                type="button"
                *ngIf="searchForm.get('search')?.value"
                class="search-clear-btn"
                (mousedown)="clearSearch($event)"
                title="Clear search"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
          </form>
        </div>
      </div>

      <!-- Right Actions -->
      <div class="header-actions flex gap-2 md:gap-3 align-items-center">
        <!-- Contact Us Button (When user not signed in) -->
        @if ($currentUser()?.default_user) {
          <button
            type="button"
            class="action-button flex align-items-center gap-2 md:gap-3 cursor-pointer"
            routerLink="/resources/contact-us"
            title="Contact Us"
          >
            <div class="icon-circle">
              <i class="pi pi-envelope"></i>
            </div>
            <div class="text-container hidden md:flex">
              <span class="action-label">Help</span>
              <span class="user-name">Contact Us</span>
            </div>
          </button>
        }

        <!-- Account Button (Simplified on Mobile) -->
        <div class="account-menu-wrapper relative">
          @if ($currentUser()?.default_user) {
            <button
              class="action-button flex align-items-center gap-2 md:gap-3 cursor-pointer"
              (click)="callLogin()"
            >
              <div class="icon-circle">
                <i class="pi pi-user"></i>
              </div>
              <div class="text-container hidden md:flex">
                <span class="action-label">Account</span>
                <span class="user-name">Sign In</span>
              </div>
            </button>
          } @else {
            <button
              class="action-button flex align-items-center gap-2 md:gap-3 cursor-pointer"
              routerLink="/account-information"
            >
              <div class="icon-circle">
                <i class="pi pi-user"></i>
              </div>
              <div class="text-container hidden md:flex">
                <span class="action-label">Account</span>
                <span class="user-name">{{
                  $currentUser()?.full_name || 'My Account'
                }}</span>
              </div>
            </button>

            <!-- Desktop Dropdown Menu (Hidden on Mobile if we put it in Sidebar) -->
            <div class="account-dropdown hidden lg:block">
              <div class="dropdown-header">
                <p class="welcome-text">Account</p>
                <p class="user-email">{{ $currentUser()?.user_email }}</p>
              </div>
              <ul class="dropdown-list">
                <li>
                  <a routerLink="/account-information" class="dropdown-item">
                    <i class="pi pi-user-edit"></i> Profile
                  </a>
                </li>
                <li>
                  <a routerLink="/orders/list" class="dropdown-item">
                    <i class="pi pi-list"></i> Orders
                  </a>
                </li>
                <li>
                  <a routerLink="/resources/contact-us" class="dropdown-item">
                    <i class="pi pi-envelope"></i> Contact Us
                  </a>
                </li>
                <li class="divider"></li>
                <li>
                  <a (click)="logout()" class="dropdown-item logout-item">
                    <i class="pi pi-sign-out"></i> Log Out
                  </a>
                </li>
              </ul>
            </div>
          }
        </div>

        <button
          class="action-button flex align-items-center gap-2 md:gap-3 cursor-pointer relative"
          [routerLink]="
            $orderDetail()?._id
              ? ['/orders', 'detail', 'edit', $orderDetail()._id]
              : ['/orders', 'detail', 'edit', 'empty']
          "
        >
          <div class="icon-circle relative">
            <i class="pi pi-shopping-bag"></i>
            <span class="cart-badge" *ngIf="$cartCount() > 0">{{
              $cartCount()
            }}</span>
          </div>
          <div class="text-container hidden md:flex">
            <span class="action-label">{{
              $cartCount() > 0 ? $formattedOrderId() : 'Cart'
            }}</span>
            <span class="user-name" *ngIf="$cartCount() > 0"
              >{{ $cartCount() }} Items</span
            >
            <span class="user-name" *ngIf="!$cartCount() || $cartCount() === 0"
              >Cart</span
            >
          </div>
        </button>
      </div>
    </div>

    <!-- Mobile Search Bar (Below Header on Mobile, hidden when scrolled) -->
    <div
      class="mobile-search lg:hidden container pt-2"
      [class.hidden-search]="!isSearchFocused && isScrolled()"
    >
      <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
        <span class="p-input-icon-left w-full relative block">
          <i class="pi pi-search"></i>
          <input
            type="text"
            pInputText
            formControlName="search"
            (focus)="onSearchFocus()"
            (blur)="onSearchBlur()"
            placeholder="Search products..."
            class="w-full search-input"
          />
          <button
            type="button"
            *ngIf="searchForm.get('search')?.value"
            class="search-clear-btn"
            (mousedown)="clearSearch($event)"
            title="Clear search"
          >
            <i class="pi pi-times"></i>
          </button>
        </span>
      </form>
    </div>
  </header>

  <!-- Navigation Menu Section (Hidden on Mobile, replaced by sidebar) -->
  <nav class="category-nav hidden lg:block">
    <div class="container h-full nav-scroll-wrap">
      <button
        type="button"
        class="nav-scroll-hint left"
        [class.visible]="canScrollNavLeft()"
        [attr.tabindex]="canScrollNavLeft() ? 0 : -1"
        aria-label="Scroll categories left"
        (click)="scrollNav(-1)"
      >
        <i class="pi pi-chevron-left"></i>
      </button>
      <ul
        #navScroller
        class="nav-menu flex align-items-center h-full"
        (scroll)="onNavScroll()"
      >
        <li
          class="nav-item cursor-pointer"
          *ngFor="
            let menu of $menusItems();
            let i = index;
            let count = count;
            let first = first
          "
          [class.special-offers]="first"
          (mouseenter)="setHoveredMenu(menu, $event, i > count - 3)"
          (mouseleave)="clearHoveredMenu()"
        >
          <a
            class="nav-link-text flex align-items-center gap-2"
            [routerLink]="['/category', menu.alias]"
          >
            <span class="flame-icon" *ngIf="first">🔥</span>
            <strong *ngIf="first">{{ menu.title }}</strong>
            <ng-container *ngIf="!first">{{ menu.title }}</ng-container>
            <i class="pi pi-chevron-down text-xs"></i>
          </a>

          <!-- Mega Menu Dropdown -->
          <div
            class="mega-menu"
            [class.mega-menu-right]="i > count - 3"
            [style.top.px]="megaMenuPos()?.top"
            [style.left.px]="megaMenuPos()?.left"
            *ngIf="hoveredMenu() === menu && menu.childs.length > 0"
          >
            <div
              class="mega-menu-header flex justify-content-between align-items-center"
            >
              <span class="header-promo"
                >Elevate your business with our custom printing solutions.</span
              >
              <a
                class="view-all flex align-items-center gap-2"
                [routerLink]="['/category', menu.alias]"
              >
                View all {{ menu.title }}
                <i class="pi pi-arrow-right text-xs"></i>
              </a>
            </div>

            <div class="mega-menu-body">
              <div
                class="mega-col"
                *ngFor="let col of splitIntoColumns(menu.childs)"
              >
                <ng-container *ngFor="let child of col">
                  <a
                    class="column-title"
                    [routerLink]="['/category', menu.alias, child.alias]"
                    >{{ child.title }}</a
                  >
                  <ul class="column-list">
                    <li
                      class="column-item"
                      *ngFor="let grandChild of child.childs"
                    >
                      <a
                        [routerLink]="[
                          '/category',
                          menu.alias,
                          child.alias + '--' + grandChild.alias,
                        ]"
                        class="item-link"
                      >
                        <span class="item-bullet">&#8226;</span>
                        <div class="item-info">
                          <div class="item-name">{{ grandChild.title }}</div>
                          <div class="item-desc" *ngIf="grandChild.description">
                            {{ grandChild.description }}
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </ng-container>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item cursor-pointer">
          <a
            class="nav-link-text flex align-items-center gap-2"
            routerLink="/blog"
          >
            Blog
          </a>
        </li>
      </ul>
      <button
        type="button"
        class="nav-scroll-hint right"
        [class.visible]="canScrollNavRight()"
        [attr.tabindex]="canScrollNavRight() ? 0 : -1"
        aria-label="Scroll categories right"
        (click)="scrollNav(1)"
      >
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>
  </nav>

  <!-- Mobile Sidebar Menu -->
  <p-sidebar
    [(visible)]="mobileMenuVisible"
    position="left"
    [baseZIndex]="10000"
    [modal]="true"
    [showCloseIcon]="false"
    styleClass="mobile-nav-sidebar"
  >
    <ng-template pTemplate="header">
      <div class="sidebar-logo">
        <img
          [src]="displayImage($currentUser()?.company?.logo_file || 'logo.png')"
          alt="Logo"
          class="h-3rem"
        />
      </div>
    </ng-template>

    <!-- Custom Close Button (Always visible at top right when menu is open) -->
    <button
      class="mobile-menu-close-btn"
      (click)="closeMobileMenu()"
      *ngIf="mobileMenuVisible()"
    >
      <i class="pi pi-times"></i>
    </button>

    <div class="sidebar-content">
      <!-- Main Scrollable Area -->
      <div class="sidebar-scroll-area">
        <!-- Sidebar Search Bar -->
        <div class="sidebar-search-container" *ngIf="!selectedSidebarMenu()">
          <form
            [formGroup]="searchForm"
            (ngSubmit)="onSearch(); closeMobileMenu()"
          >
            <span class="p-input-icon-left w-full relative block">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInputText
                formControlName="search"
                (focus)="onSearchFocus()"
                (blur)="onSearchBlur()"
                placeholder="Search for products..."
                class="w-full sidebar-search-input"
              />
              <button
                type="button"
                *ngIf="searchForm.get('search')?.value"
                class="search-clear-btn"
                (mousedown)="clearSearch($event)"
                title="Clear search"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
          </form>
        </div>

        <!-- Level 1: Main Menu Categories -->
        <ul class="mobile-nav-list" *ngIf="!selectedSidebarMenu()">
          <li class="nav-section-title">Shop by Category</li>
          <li *ngFor="let menu of $menusItems(); let first = first">
            <div
              class="mobile-nav-item"
              [class.special]="first"
              (click)="selectSidebarMenu(menu)"
            >
              <span class="flame" *ngIf="first">🔥</span>
              <span class="nav-link">{{ menu.title }}</span>
              <i
                class="pi pi-chevron-right ml-auto text-xs opacity-50"
                *ngIf="menu.childs?.length"
              ></i>
            </div>
          </li>
        </ul>

        <!-- Level 2: Sub Menu -->
        <div class="mobile-sub-menu" *ngIf="selectedSidebarMenu()">
          <div class="sub-menu-header" (click)="goBackSidebar()">
            <i class="pi pi-arrow-left"></i>
            <span>Back to Categories</span>
          </div>

          <div class="sub-menu-parent-info">
            <h2 class="sub-menu-parent-title">
              {{ selectedSidebarMenu().title }}
            </h2>
            <a
              [routerLink]="['/category', selectedSidebarMenu().alias]"
              (click)="closeMobileMenu()"
              class="view-all-link"
            >
              View all {{ selectedSidebarMenu().title }} products
              <i class="pi pi-arrow-right"></i>
            </a>
          </div>

          <div class="sub-menu-scroll-content">
            <div
              class="sub-category-group"
              *ngFor="let child of selectedSidebarMenu().childs"
            >
              <a
                [routerLink]="[
                  '/category',
                  selectedSidebarMenu().alias,
                  child.alias,
                ]"
                (click)="closeMobileMenu()"
                class="group-title"
              >
                {{ child.title }}
                <i class="pi pi-chevron-right"></i>
              </a>

              <ul class="child-item-list">
                <li *ngFor="let grandChild of child.childs">
                  <a
                    [routerLink]="[
                      '/category',
                      selectedSidebarMenu().alias,
                      child.alias + '--' + grandChild.alias,
                    ]"
                    (click)="closeMobileMenu()"
                    class="child-item"
                  >
                    <span class="bullet"></span>
                    {{ grandChild.title }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Sticky Footer Area (Only on Level 1) -->
      <div class="sidebar-footer" *ngIf="!selectedSidebarMenu()">
        <!-- Modern User Card -->
        <div
          class="sidebar-user-card"
          *ngIf="!$currentUser()?.default_user"
          routerLink="/account-information"
          (click)="closeMobileMenu()"
        >
          <div class="user-avatar-wrapper">
            <div class="user-avatar">
              <i class="pi pi-user"></i>
            </div>
            <div class="status-indicator"></div>
          </div>
          <div class="user-info">
            <span class="user-name">{{ $currentUser()?.full_name }}</span>
            <span class="user-email">{{ $currentUser()?.user_email }}</span>
          </div>
          <i class="pi pi-chevron-right ml-auto text-400"></i>
        </div>

        <ul class="mobile-nav-list pt-0">
          <li class="nav-section-title">Account & Support</li>

          <li *ngIf="$currentUser()?.default_user">
            <a class="mobile-nav-item" (click)="callLogin(); closeMobileMenu()">
              <i class="pi pi-sign-in"></i> Sign In
            </a>
          </li>

          <li *ngIf="!$currentUser()?.default_user">
            <a
              routerLink="/orders/list"
              (click)="closeMobileMenu()"
              class="mobile-nav-item"
            >
              <i class="pi pi-list"></i> My Orders
            </a>
          </li>
          <li>
            <a
              routerLink="/blog"
              (click)="closeMobileMenu()"
              class="mobile-nav-item"
            >
              <i class="pi pi-book"></i> Blog
            </a>
          </li>
          <li>
            <a
              routerLink="/resources/contact-us"
              (click)="closeMobileMenu()"
              class="mobile-nav-item"
            >
              <i class="pi pi-envelope"></i> Contact Us
            </a>
          </li>
          <li *ngIf="!$currentUser()?.default_user" class="mt-3 px-3">
            <button
              (click)="logout(); closeMobileMenu()"
              class="mobile-logout-btn"
            >
              <i class="pi pi-sign-out mr-2"></i> Log Out
            </button>
          </li>
        </ul>
      </div>
    </div>
  </p-sidebar>
</div>

<!-- Unified Auth Dialog -->
<p-dialog
  [draggable]="false"
  [modal]="true"
  [(visible)]="popupLogin"
  styleClass="custom-login-dialog"
  [closable]="false"
  [showHeader]="false"
  [style]="{ width: '1200px', maxWidth: '95%' }"
  [closeOnEscape]="true"
  (onHide)="onDialogHide()"
>
  <div class="auth-dialog-wrapper">
    <!-- Close Button -->
    <button
      class="close-dialog-btn"
      (click)="popupLogin = false; onDialogHide()"
    >
      <i class="pi pi-times"></i>
    </button>

    <!-- Left Column: Forms -->
    <div class="auth-form-column">
      <div class="auth-tabs">
        <button
          class="auth-tab"
          [class.active]="isLoginView"
          (click)="isLoginView = true"
        >
          Sign In
        </button>
        <button
          class="auth-tab"
          [class.active]="!isLoginView"
          (click)="isLoginView = false"
        >
          Create Account
        </button>
      </div>

      <!-- Login View -->
      <div *ngIf="isLoginView" class="fadein flex flex-column gap-4">
        <div class="form-group">
          <label>Email Address<span class="required">*</span></label>
          <div class="input-wrapper">
            <i class="pi pi-envelope"></i>
            <input
              type="text"
              class="login-input"
              [(ngModel)]="loginFormGroup.value.username"
              [formControl]="loginFormGroup.controls.username"
              placeholder="john.doe&#64;example.com"
            />
          </div>
        </div>

        <div class="form-group">
          <label>Password<span class="required">*</span></label>
          <div class="input-wrapper">
            <i class="pi pi-lock"></i>
            <input
              [type]="showPass ? 'text' : 'password'"
              class="login-input"
              [(ngModel)]="loginFormGroup.value.password"
              [formControl]="loginFormGroup.controls.password"
              placeholder="********"
              (keydown.enter)="login()"
            />
            <i
              class="pi toggle-pass"
              [ngClass]="showPass ? 'pi-eye-slash' : 'pi-eye'"
              (click)="showPass = !showPass"
            ></i>
          </div>
          <div class="flex justify-content-end mt-2">
            <a
              (click)="forgotPassword()"
              class="text-lg text-blue-600 cursor-pointer underline"
              >Forgot Password?</a
            >
          </div>
        </div>

        <button
          class="submit-btn"
          [disabled]="loginFormGroup.invalid || isLoading"
          (click)="login()"
        >
          <i class="pi pi-spinner pi-spin mr-2" *ngIf="isLoading"></i>
          Sign In to Your Account
        </button>
      </div>

      <!-- Register View -->
      <div *ngIf="!isLoginView" class="fadein">
        <div class="form-grid">
          <div class="form-group">
            <label>First Name<span class="required">*</span></label>
            <div class="input-wrapper">
              <i class="pi pi-user"></i>
              <input
                type="text"
                class="login-input"
                [formControl]="registerFormGroup.controls.user_first_name"
                placeholder="John"
              />
            </div>
          </div>
          <div class="form-group">
            <label>Last Name<span class="required">*</span></label>
            <div class="input-wrapper">
              <i class="pi pi-user"></i>
              <input
                type="text"
                class="login-input"
                [formControl]="registerFormGroup.controls.user_last_name"
                placeholder="Doe"
              />
            </div>
          </div>
          <div class="form-group full-width">
            <label>Phone Number<span class="required">*</span></label>
            <div class="input-wrapper">
              <i class="pi pi-phone"></i>
              <input
                type="text"
                class="login-input"
                [formControl]="registerFormGroup.controls.user_phone"
                placeholder="(403) 123-4567"
              />
            </div>
          </div>
          <div class="form-group full-width">
            <label>Email Address<span class="required">*</span></label>
            <div class="input-wrapper">
              <i class="pi pi-envelope"></i>
              <input
                type="text"
                class="login-input"
                [formControl]="registerFormGroup.controls.user_email"
                placeholder="john.doe&#64;example.com"
                (focus)="clearErrorMessage()"
              />
            </div>
            <div *ngIf="errorMessage" class="text-xs text-red-500 mt-1">
              {{ errorMessage }}
            </div>
          </div>
          <div class="form-group full-width">
            <label>Password<span class="required">*</span></label>
            <div class="input-wrapper">
              <i class="pi pi-lock"></i>
              <input
                type="password"
                class="login-input"
                [formControl]="registerFormGroup.controls.user_password"
                placeholder="********"
              />
            </div>
          </div>
        </div>

        <div class="terms-text flex gap-3">
          <p-checkbox
            [binary]="true"
            inputId="terms"
            [formControl]="registerFormGroup.controls.terms"
          ></p-checkbox>
          <label class="text-lg" for="terms">
            I agree to the <a href="#">Terms & Conditions</a> and
            <a href="#">Privacy Policy</a>
          </label>
        </div>

        <button
          class="submit-btn mt-4"
          [disabled]="registerFormGroup.invalid || isLoading"
          (click)="registerUser()"
        >
          <i class="pi pi-spinner pi-spin mr-2" *ngIf="isLoading"></i>
          Create Your Account
        </button>

        <!-- <div class="promo-optin">
          <div class="optin-content">
            <p class="optin-title">
              <i class="pi pi-megaphone"></i> Keep me updated with special
              offers
            </p>
            <p class="optin-desc">
              Get exclusive deals, new product announcements, and printing tips
              delivered to your inbox.
            </p>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Right Column: Benefits -->
    <div class="auth-info-column">
      <!-- Image underneath the sign in button as requested -->
      <img
        *ngIf="login_banner"
        [src]="displayImage(login_banner)"
        class="login-banner-img"
        alt="Login Banner"
      />

      <div class="benefits-section">
        <div class="section-header">
          <h2>Why Create an Account?</h2>
        </div>

        <div class="benefit-list">
          <div class="benefit-item blue">
            <div class="item-icon">
              <i class="pi pi-box"></i>
            </div>
            <div class="item-content">
              <p class="item-title">Track Your Orders</p>
              <p class="item-desc">
                Monitor order status, view history, and reorder with ease.
              </p>
            </div>
          </div>

          <div class="benefit-item purple">
            <div class="item-icon">
              <i class="pi pi-credit-card"></i>
            </div>
            <div class="item-content">
              <p class="item-title">Fast Checkout</p>
              <p class="item-desc">
                Save payment methods and shipping addresses for quick ordering.
              </p>
            </div>
          </div>

          <div class="benefit-item yellow">
            <div class="item-icon">
              <i class="pi pi-heart"></i>
            </div>
            <div class="item-content">
              <p class="item-title">Exclusive Offers</p>
              <p class="item-desc">
                Get special discounts and early access to new products.
              </p>
            </div>
          </div>

          <div class="benefit-item green">
            <div class="item-icon">
              <i class="pi pi-map-marker"></i>
            </div>
            <div class="item-content">
              <p class="item-title">Saved Designs</p>
              <p class="item-desc">
                Store and reuse your custom designs for future orders.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="help-section">
        <div class="help-header">
          <div class="help-icon">
            <i class="pi pi-question-circle"></i>
          </div>
          <div class="help-title">
            <span>Need Help?</span>
            <span>We're here for you 24/7</span>
          </div>
        </div>
        <p class="help-desc">
          Our team is here to assist you with any questions about your account
          or orders.
        </p>
        <div class="contact-links">
          <a href="tel:4032912244" class="contact-item">
            <div class="c-icon"><i class="pi pi-phone"></i></div>
            <div class="c-info">
              <span>Call Us</span>
              <span>(403) 291-2244</span>
            </div>
            <i class="pi pi-chevron-right"></i>
          </a>
          <a
            routerLink="/resources/contact-us"
            (click)="popupLogin = false"
            class="contact-item"
          >
            <div class="c-icon"><i class="pi pi-envelope"></i></div>
            <div class="c-info">
              <span>Contact Us</span>
              <span>Send us a message</span>
            </div>
            <i class="pi pi-chevron-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Forgot Password Dialog -->
<p-dialog
  [draggable]="false"
  [modal]="true"
  [(visible)]="popupForgetPassword"
  styleClass="custom-login-dialog"
  [closable]="false"
  [showHeader]="false"
  [style]="{ width: '450px', maxWidth: '95%' }"
  [closeOnEscape]="true"
  (onHide)="onDialogHide()"
>
  <div class="auth-dialog-wrapper single-col">
    <button
      class="close-dialog-btn"
      (click)="popupForgetPassword = false; onDialogHide()"
    >
      <i class="pi pi-times"></i>
    </button>

    <div class="auth-form-column">
      <div class="text-center mb-6">
        <div class="header-icon-circle mx-auto mb-4">
          <i class="pi pi-lock-open text-3xl"></i>
        </div>
        <h1 class="text-2xl font-bold text-gray-900 m-0">Forgot Password?</h1>
        <p class="text-lg text-gray-500 mt-2">
          No worries! Enter your email and we'll send you a link to reset your
          password.
        </p>
      </div>

      <form
        [formGroup]="forgetEmailFormGroup"
        autocomplete="off"
        class="flex flex-column gap-4"
        (ngSubmit)="resetPassword()"
      >
        <ng-container *ngIf="resetMessage?.type !== 'success'">
          <div class="form-group">
            <label>Email Address<span class="required">*</span></label>
            <div class="input-wrapper">
              <i class="pi pi-envelope"></i>
              <input
                type="text"
                class="login-input"
                formControlName="forget_email"
                placeholder="john.doe&#64;example.com"
              />
            </div>
          </div>

          <button
            type="submit"
            class="submit-btn"
            [disabled]="forgetEmailFormGroup.invalid || isLoading"
          >
            <i class="pi pi-spinner pi-spin mr-2" *ngIf="isLoading"></i>
            Send Reset Link
          </button>
        </ng-container>

        <div
          *ngIf="resetMessage"
          class="reset-message flex align-items-center gap-2 border-round"
          [ngClass]="{
            'bg-green-50 text-green-700 border-1 border-green-200 flex-column text-center p-5 gap-3 border-round-lg':
              resetMessage.type === 'success',
            'bg-red-50 text-red-700 border-1 border-red-200 p-3 border-round-3xl':
              resetMessage.type === 'error',
          }"
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-check-circle': resetMessage.type === 'success',
              'pi-times-circle': resetMessage.type === 'error',
            }"
            [style.font-size]="
              resetMessage.type === 'success' ? '3rem' : '1rem'
            "
          ></i>
          <span
            [class]="
              resetMessage.type === 'success'
                ? 'text-xl font-semibold'
                : 'text-lg'
            "
          >
            {{ resetMessage.text }}
          </span>
        </div>

        <div class="text-center">
          <a
            (click)="callLogin()"
            class="text-lg font-semibold text-blue-600 hover:text-blue-800 cursor-pointer no-underline flex align-items-center justify-content-center gap-2"
          >
            <i class="pi pi-arrow-left text-xs"></i>
            Back to Sign In
          </a>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
